import type { EditorCommand } from '@atlaskit/editor-common/types';

import { type MalleableUiPluginMeta, malleableUiPluginKey } from '../pm-plugins/plugin-key';

/**
 * Records (or clears, with `undefined`) the in-flight diagram remix's whiteboard contentId, so the
 * ready-signal UI can target that board node. Set at streaming-start; cleared when a new remix starts.
 */
export const setRemixDiagramContentId =
	(remixDiagramContentId: string | undefined): EditorCommand =>
	({ tr }) => {
		tr.setMeta(malleableUiPluginKey, { remixDiagramContentId } satisfies MalleableUiPluginMeta);

		return tr;
	};
